import { render, staticRenderFns } from "./TheTopbarUserMenu.vue?vue&type=template&id=31ea1464&"
import script from "./TheTopbarUserMenu.vue?vue&type=script&lang=js&"
export * from "./TheTopbarUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports